import { ISKAN_PARENT_BASVURU_OLUSTUR } from "../constants/requestUrls";

import { postRequest } from "../request";

const IskanParentBasvuruOlustur = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: ISKAN_PARENT_BASVURU_OLUSTUR, data });
}

export default IskanParentBasvuruOlustur;